export default __webpack_public_path__ + "static/media/Brew Eggs Benny -proportioned_170.f162ffcf.jpg";